import clsx from 'clsx';
import { h } from 'preact';
import { useThreekit } from '../threekit-context';
import ThreekitIcons from './threekit-icons';
import { useModal } from '../modal-context';

function InspoButton() {
  const { openModal } = useModal();
  const { darkMode } = useThreekit();

  return (
    <button
      onClick={() => openModal('Inspo')}
      className={clsx(
        'flex gap-[7px] items-center px-[13px] justify-center text-center laptop:border-[0.6px] rounded-sm border-none',
        {
          'bg-black bg-opacity-20 text-white': darkMode,
          'bg-white text-black': !darkMode,
        },
      )}
    >
      <ThreekitIcons type="inspo" className="w-[18px]" />
      <span className="uppercase font-m-12">Inspo</span>
    </button>
  );
}

export default InspoButton;
